import axios from "axios";

export const request = axios.create({
    baseURL: "https://ssl.kfzgutachteneuropa-system.de/api",
    // baseURL: "http://localhost:8000/api",
    /* Put the domain of backend */
});